import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import address from "./address";

import CONFIG_API from "./config/development.js";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    address
  },

  state: {
    offices: {},
    candidate: {},
    projects: [],
    donations: [],
    tickets: [],
    donationPlatforms: [],
    donationSources: [],
    hasMoreDonations: false,
    lastDonationMarker: '',
    lastTicketMarker: '',
    device: "",
    statusPaymentRequest: {},
    paymentError: "",
    paymentData: {},

    ticketStep: "intro",
    // from rede
    paymentStep: "selectValue",
    amount: 0,
    referral: '',
    token: "",
    donation: {},
    iugu: {},
    messages: [],
    username: {},
    candidateId: "",
    userData:{},
    receipt: {},
    deposit: {
      donations: [],
      candidate: {
        id: 0,
        avatar: '',
        popular_name: '',
      },
      meta: {
        created_at: '',
      },
    },
  },

  actions: {
    getOffices: ({ commit }) => {
      return new Promise((resolve, reject) => {

        const offices = [{"name":"Prefeito(a)","id":10},{"name":"Vereador(a)","id":11},{"id":12,"name":"Vice-prefeito(a)"}];
        commit('setOfficesList', offices),
        resolve(offices);
        /* axios
          .get(
            `${CONFIG_API.api}/api/office`
          )
          .then(response => {
            return (response.data.office);
          })
          .then(offices => {
            commit('setOfficesList', offices),
            resolve(offices);
          })
          .catch(err => {
            console.error('erro', err.response);
            reject(err.response);
          });*/
      });
    },

    getCandidate: ({ commit }, candidateName) => {
      return new Promise((resolve, reject) => {
        axios
          .get(
            `${CONFIG_API.api}/public-api/candidate-summary/${candidateName}`
          )
          .then(response => {
            resolve(response.data.candidate);
            commit("getCandidateMutation", response.data.candidate);
            commit("getCandidateMutationProjects", response.data.candidate.projects);
            if (response.data.platforms) {
              commit('SET_SOURCES', response.data.platforms);
            }
          })
          .catch(err => {
            console.error('erro', err.response);
            reject(err.response);
          });
      });
    },

    getCandidateProjects: ({ commit }, candidate) => {
      return new Promise(resolve => {
        axios
          .get(`${CONFIG_API.api}/api/candidate/${candidate}/projects`)
          .then(response => {
            resolve(response.data.projects);
            commit("getCandidateMutationProjects", response.data.projects);
          });
      });
    },

    getCandidateDonations: ({ commit, state }, candidate) => {
      return new Promise(resolve => {
        axios
        .get(`${CONFIG_API.api}/public-api/candidate-donations/${candidate}/${state.lastDonationMarker}`)
          .then(response => {
            resolve(response.data.donations);
            commit("getCandidateMutationDonations", response.data);
          });
      });
    },

    getCandidateTickets: ({ commit, state }, candidate) => {
      return new Promise(resolve => {
        axios
        .get(`${CONFIG_API.api}/public-api/candidate-tickets/${candidate}/${state.lastTicketMarker}`)
          .then(response => {
            resolve(response.data.tickets);
            commit("getCandidateMutationTickets", response.data);
          });
      });
    },

    postHiuguDevice: ({ commit }) => {
      return new Promise(resolve => {
        axios
          .post(`${CONFIG_API.api}/api2/device-authentication`)
          .then(response => {
            resolve(response.data.device_authorization_token_id);
            commit("hiuguDevice", response.data.device_authorization_token_id);
          });
      });
    },

	GET_RECEIPT({ commit }, payload) {
		return new Promise((resolve, reject) => {
			axios.get(`${CONFIG_API.api}/public-api/candidate/${payload.candidateId}/donation/digest/${payload.digest}`).then(
				(response) => {
					commit('SET_RECEIPT', {
						res: response.data
					});
					resolve();
				},
				(err) => {
					reject(err.response);
				},
			);
		});
	},

  GET_DEPOSIT({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.get(`${CONFIG_API.api}/public-api/candidate/${payload.candidateId}/deposit?deposit_id=${payload.depositId}`).then(
        (response) => {
          commit('SET_DEPOSIT', {
            res: response.data
          });
          resolve();
        },
        (err) => {
          reject(err.response);
        },
      );
    });
  },

    // from rede
    CHANGE_PAYMENT_AMOUNT({ commit }, data) {
      commit("SET_PAYMENT_STEP", { data });
      commit("SET_PAYMENT_AMOUNT", { data });
    },
    CHANGE_PAYMENT_STEP({ commit }, data) {
      commit("SET_PAYMENT_STEP", { data });
    },
    SAVE_USERNAME({ commit }, user) {
      commit("SET_USERNAME", { user });
    },
    ADD_TOKEN({ commit }, data) {
      commit("SET_TOKEN", { token: data });
    },
    GET_TOKEN({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios({
          method: "POST",
          headers: { "Content-Type": "application/json" },
          url: `${CONFIG_API.api}/api2/device-authentication`,
          data
        })
          .then(response => {
            const { device_authorization_token_id } = response.data;
            commit("SET_TOKEN", { token: device_authorization_token_id });
            resolve(response);
          })
          .catch(err => {
            console.error(err.response);
            reject(err.response);
          });
      });
    },
    SAVE_PAYMENT_DATA({ commit }, data) {
      commit('SET_PAYMENT_DATA', { paymentData: data });
    },

    SEND_TICKET({ commit}, data) {
      return new Promise((resolve, reject) => {
        const keys = {
          candidate_id: 'candidate_id',
          device_authorization_token_id: 'device_authorization_token_id',
          donation_fp: 'donation_fp',
          address_complement: 'complemento',
          address_district: 'bairro',
          address_house_number: 'numero',
          address_state: 'estado',
          address_street: 'endereco',
          address_zipcode: 'cep',
          address_city: 'cidade',
          birthdate: 'nascimento',
          cpf: 'cpf',
          email: 'email',
          name: 'nome',
          surname: 'sobrenome',
          phone: 'telefone',
        };

        const translatedAndCleanData = Object.keys(data).reduce((acc, cur) => {
          if (keys[cur]) {
            acc[keys[cur]] = data[cur];
          }
          return acc;
        }, {});

        axios({
          method: "POST",
          headers: { "Content-Type": "application/json" },
          url: `${CONFIG_API.api}/api2/rede-ticket`,
          data: translatedAndCleanData,
        }).then(
          response => {
            if (response.data && response.data.ui && response.data.ui.messages) {
              commit("SET_MESSAGES", { messages: response.data.ui.messages });
            }

            resolve();
          },
          err => {
            console.error(err.response);
            reject(err.response);
          }
        );
      });
    },

    GET_DONATION({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios({
          method: "POST",
          headers: { "Content-Type": "application/json" },
          url: `${CONFIG_API.api}/api2/donations`,
          data,
        }).then(
          response => {
            const { donation, ui } = response.data;
            commit("SET_DONATION", { donation });
            commit("SET_IUGU", { iugu: ui.messages[1] });
            commit("SET_MESSAGES", { messages: response.data.ui.messages });
            resolve();
          },
          err => {
            console.error(err.response);
            reject(err.response);
          }
        );
      });
    },
    START_DONATION({ commit, state }, payload) {
      return new Promise((resolve, reject) => {
        axios({
          method: "POST",
          headers: { "Content-Type": "application/json" },
          url: `${CONFIG_API.api}/api2/donations/${state.donation
            .id}?device_authorization_token_id=${state.token}&credit_card_token=${payload.id}&cc_hash=${payload.cc_hash}`
        }).then(
          response => {
            const data = {
              step: "finalMessage"
            };
            commit("SET_MESSAGES", { messages: response.data.ui.messages });
            commit("SET_PAYMENT_STEP", { data });
            resolve(response);
          },
          err => {
            console.error(err.response);
            reject(err.response);
          }
        );
      });
    },
    START_DONATION_BOLETO({ commit }, payload) {
      let token = '';
      if (window.localStorage) {
      const tokenName = window.location.host === 'votolegal.com.br' || window.location.host === 'votolegal.com'
        ? 'prod_vlm_token'
        : 'dev_vlm_token';
        token = localStorage.getItem(tokenName)
      }

      return new Promise( (resolve, reject)=>{
        axios({
          method: 'GET',
          headers:{
            "Content-Type": "application/json"
          },
          url: `${CONFIG_API.api}/api2/donations/${payload.donationId}?device_authorization_token_id=${token}`
        }).then((response)=>{
          const data = {
            step: "printBoleto"
          };
          const { donation, ui } = response.data;
                commit("SET_DONATION", { donation });
          commit("SET_MESSAGES", {
            messages: ui
          });
          commit("SET_PAYMENT_STEP", {
            data
          });
          resolve(response);
        } ,error => {
          commit("SET_MESSAGES", {
              messages: {messages:[{
                  text: error.response.data[0].message
                }]}});
          console.error(error.response);
          reject(error.response);
        })
      })
    },
    GET_CANDIDATE_INFO({ commit }, id) {
      return new Promise((resolve, reject) => {
        axios.get(`${CONFIG_API.api}/api/candidate/${id}`).then(
          response => {
            commit("SET_CANDIDATE", { res: response.data });
            if (response.data.platforms) {
              commit('SET_SOURCES', response.data.platforms);
            }
            resolve();
          },
          err => {
            reject(err.response);
            console.error(err);
          }
        );
      });
    },
    GET_DONATIONS({ commit }, id) {
      return new Promise((resolve, reject) => {
        axios.get(`${CONFIG_API.api}/api/candidate/${id}/donate`).then(
          response => {
            commit("SET_DONATIONS", { res: response.data });
            if (response.data.platforms) {
              commit('SET_PLATFORMS', response.data.platforms);
            }
            resolve();
          },
          err => {
            reject(err.response);
            console.error(err);
          }
        );
      });
    },
    SAVE_ADDRESS({ commit }, payload) {
      commit('SET_ADDRESS', {userData: payload})
    },
    ADD_REFERRAL({ commit }, data) {
      commit('SET_REFERRAL', data);
    },
  },

  mutations: {
    setOfficesList: (state, payload) => {
      state.offices = payload.reduce((acc, cur) => {
        acc[cur.id] = cur.name;
        return acc;
      }, {})
    },
    getCandidateMutation: (state, payload) => {
      state.candidate = payload;
      state.candidateId = payload.id;
    },
    getCandidateMutationProjects: (state, payload) => {
      state.projects = payload;
    },
    getCandidateMutationDonations: (state, payload) => {
      state.hasMoreDonations = payload.has_more || false;
      if (payload.donations.length) {
        state.lastDonationMarker = payload.donations[payload.donations.length - 1]._marker;
      }

      state.donations = state.donations.concat(payload.donations);
    },
    getCandidateMutationTickets: (state, payload) => {
      state.hasMoreTickets = payload.has_more || false;
      if (payload.tickets.length) {
        state.lastTicketMarker = payload.tickets[payload.tickets.length - 1]._marker;
      }

      state.tickets = state.tickets.concat(payload.tickets);
    },
    SET_RECEIPT(state, { res }) {
      state.receipt = res.donation;
    },
    SET_DEPOSIT(state, { res }) {
      state.deposit = res;
    },
    // from rede
    SET_PAYMENT_DATA(state, { paymentData }) {
      state.paymentData = paymentData;
    },
    SET_PAYMENT_STEP(state, { data }) {
      state.paymentStep = data.step;
    },
    SET_TICKET_STEP(state, { step }) {
      state.ticketStep = step;
    },
    SET_PAYMENT_AMOUNT(state, { data }) {
      state.amount = data.amount;
    },
    SET_TOKEN(state, { token }) {
      state.token = token;
    },
    SET_USERNAME(state, { user }) {
      state.username = user;
    },
    SET_DONATION(state, { donation }) {
	  state.donation = donation;
    },
    SET_IUGU(state, { iugu }) {
      state.iugu = iugu;
    },
    SET_MESSAGES(state, { messages }) {
      state.messages = messages;
    },
    SET_CANDIDATE(state, { res }) {
      state.candidate = res.candidate;
    },
    SET_PLATFORMS(state, platforms) {
      state.donationPlatforms = platforms.sort(a => (['voto legal', 'votolegal'].indexOf(a.name.toLowerCase()) !== -1 ? -1 : 1));
    },
    SET_SOURCES(state, platforms) {
      const donationSources = platforms.reduce((allTypes, item) => {
        const typeName = item.type.toLowerCase();
        if (typeName in allTypes) {
          allTypes[typeName].total_donated += item.total_donated;
          allTypes[typeName].people_donated += item.people_donated;
        } else {
          allTypes[typeName] = {
            name: item.type,
            total_donated: item.total_donated,
            people_donated: item.people_donated,
          };
        }
        return allTypes;
      }, {});

      state.donationSources = Object.keys(donationSources).map(key => donationSources[key]);
    },
    SET_DONATIONS(state, { res }) {
      state.donations = res.donations;
    },
    SET_ADDRESS(state, { userData }){
      state.userData = userData;
    },
    SET_REFERRAL(state, referral) {
      state.referral = referral;
    },
  },
  getters: {
    generateCandidateObject: state => {
      const candidateMerge = {
        candidate: state.candidate,
        projects: state.projects,
        tickets: state.tickets,
        donations: state.donations
      };
      return candidateMerge;
    }
  }
});

export default store;



// WEBPACK FOOTER //
// ./_source/store/index.js